// 错误提示
<template>
<div class="g-loading no-absolute">
  <i class="u-error-flag i-icon i-icon-g-error"></i>
  <p class="u-error-info">{{showError}}</p>
</div>
</template>

<script>
export default {
  props:{
    errMsg: String
  },
  data (){
    return {
      showError : this.errMsg
    }
  },
  mounted (){
    window.Loading.loading = false;

  }
}
</script>





// WEBPACK FOOTER //
// ErrorPage.vue?1d944998